import { fanWorks, type FanWork } from "@/mocks/naruto";

function WorkCard({ work }: { work: FanWork }) {
  return (
    <article className="hover-lift group overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title} · ${work.category} · 火影同人动漫`}
          title={`${work.title} 火影同人动漫在线`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-bold text-background-50 ${
            work.status === "连载中" ? "bg-primary-500" : "bg-secondary-500"
          }`}
        >
          {work.status}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-bold text-accent-300">
          <i className="ri-star-fill text-accent-400"></i>
          {work.score}
        </span>
      </div>
      <div className="p-4">
        <h3 className="truncate font-heading text-base font-bold text-foreground-900 md:text-lg">
          {work.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {work.tags.map((tag) => (
            <span
              key={tag}
              className="rounded bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {work.intro}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line"></i>
            {work.chapters}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {work.views}
          </span>
        </div>
      </div>
    </article>
  );
}

export default function HotWorks() {
  const hotWorks = fanWorks.filter((w) => Number(w.score) >= 9.1).slice(0, 8);

  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold text-primary-600">
              <i className="ri-fire-fill"></i> 本周热门
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-4xl">
              热门作品推荐
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              由人气与口碑共同决定的高分火影同人作品，点开即看，追更不迷路。
            </p>
          </div>
          <a
            href="#latest"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-4 py-2 text-sm font-bold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 md:gap-6">
          {hotWorks.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}